module.exports = __webpack_public_path__ + "img/dingding.b08217ce.png";